import React from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button } from '@material-ui/core';
import css from './styles.module.scss';
import TextField from '@material-ui/core/TextField';
import classNames from 'classnames';

interface Props {
    id: number | string;
    onSubmit(upc: number): void;
}

const MAX_LENGTH = 9999999999999;

export const UpcForm: React.FC<Props> = ({ id, onSubmit }) => {
    const { handleSubmit, register, reset, errors } = useForm<{ [name: string]: number }>();

    const fieldName = `track-add-upc-${id}`;

    const onAdd = (data: { [name: string]: number }): void => {
        onSubmit(data[fieldName]);
        reset();
    };

    return (
        <Box className={css.upcInputWrapper}>
            <TextField
                className={classNames(css.textInput, css.btnInput, css.upcInput)}
                variant="filled"
                type="number"
                inputProps={{ max: MAX_LENGTH }}
                name={fieldName}
                inputRef={register({ max: MAX_LENGTH })}
                error={!!(errors && errors[fieldName])}
                helperText={errors && errors[fieldName] && errors[fieldName]?.message}
            />
            <Button
                type="button"
                className={classNames(css.addFeature, css.upcAddBtn)}
                onClick={(e) => handleSubmit(onAdd)(e)}
            />
        </Box>
    );
};
